if ( document.location.pathname.indexOf( "/design-portfolio/" ) == 0 ) {
    jQuery( '#menu-item-5502' ).removeClass( 'current_page_parent' );
    jQuery( '#menu-item-5504' ).addClass( 'current_page_parent' );
}


// Show a play button if the video fails to autoplay
jQuery( function( $ ) {
    const $button = $( '.portbanner .video-container .play-button' );
    const video = document.querySelector( '.portbanner .video-container video' );
    if ( !video ) return;

    video.addEventListener( 'play', hideButton );

    if ( video.paused ) {
        showButton();
    } else {
        hideButton();
        video.removeEventListener('play', hideButton);
    }

    function showButton() {
        $button.fadeIn();
        $button.on( 'click', function() {
            video.play();
            hideButton();
        } );
    }
    function hideButton() {
        if ( $button.get( 0 ).style.display === 'none' ) return;
        $button.fadeOut();
    }
} );

jQuery( function( $ ) {
    if ( document.querySelector( '.social-gallery' ) ) {
        $( '.social-gallery' ).slick( {
            centerMode: true,
            centerPadding: '16%',
            slidesToShow: 3,
            swipeToSlide: true,
            slidesToScroll: 1,
            autoplay: true,
            autoplaySpeed: 3000,
            infinite: true,
            pauseOnHover: false,
            arrows: true,
            prevArrow: '<svg class="slick-arrow slick-prev" xmlns="http://www.w3.org/2000/svg" width="24.571" height="36.413" viewBox="0 0 24.571 36.413"><path d="M21.388 33.231 6.363 18.206 21.388 3.181" fill="none" stroke="#e4034b" stroke-width="9"/></svg>',
            nextArrow: '<svg class="slick-arrow slick-next" xmlns="http://www.w3.org/2000/svg" width="24.571" height="36.413" viewBox="0 0 24.571 36.413"><path d="m3.182 3.182 15.025 15.025L3.182 33.232" fill="none" stroke="#e4034b" stroke-width="9"/></svg>',
            responsive: [
                {
                    breakpoint: 1300,
                    settings: {
                        slidesToShow: 3,
                    }
                },
                {
                    breakpoint: 1023,
                    settings: {
                        centerPadding: '10%',
                        slidesToShow: 2,
                    }
                },
                {
                    breakpoint: 540,
                    settings: {
                        centerPadding: '5%',
                        slidesToShow: 1,
                    }
                }
            ]
        } );
    }
} );